import React, { useContext } from 'react';
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from 'firebase/auth';
import { Loading, UserCard } from 'src/components';
import { Pane, Heading, Button, Card } from 'evergreen-ui';
import { useNavigate } from 'react-router';
import AuthContext from 'src/providers/authProvider';
import '../styles.css'

const AdminLogin = () => {
  const { loading, isLoggedIn, isAdmin } = useContext(AuthContext);
  const auth = getAuth();
  const provider = new GoogleAuthProvider();

  const onSignIn = () => signInWithPopup(auth, provider);
  const onSignOut = async () => {
    signOut(auth);
    window.location.reload();
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Pane width="100vw" height="100vh" display="flex" justifyContent="center" alignItems="center">
      <Card padding="30px" width="80%" maxWidth={350} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Heading size="900" marginBottom="12px">
          Admin Login
        </Heading>
        {isLoggedIn ? <LoggedIn onSignOut={onSignOut} isAdmin={isAdmin} /> : <LoggedOut onSignIn={onSignIn} />}
      </Card>
    </Pane>
  );
};

const LoggedIn = ({ onSignOut, isAdmin }) => {
  const navigate = useNavigate();
  const onNavigateToControlPanel = () => {
    navigate('/admin');
  };
  return (
    <>
      <UserCard />
      <Pane display="flex" justifyContent="space-between" alignItems="center" width="100%">
        <Button onClick={onSignOut}>Sign out</Button>
        {isAdmin && (
          <Button onClick={onNavigateToControlPanel} appearance="primary">
            Go to Control Panel
          </Button>
        )}
      </Pane>
    </>
  );
};

const LoggedOut = ({ onSignIn }) => {
  return (
    <Button onClick={onSignIn} appearance="primary" width="185px">
      Sign in
    </Button>
  );
};

export default AdminLogin;
